/*var boton='<li class="nav-bar__item"><a href="/pages/sucursales" class="nav-bar__link link" data-type="menuitem"'
+'style="padding:2px 10px;background:#ffffff;border:solid 1px #ccc;border-radius: 2px;font-size:0;line-height:10px;"><span style="'
   +' display: block;font-size: 18px;margin-top: 3px;">'+localStorage.getItem('suc_name')+'</span><br><span style=" font-size: 12px;'
+'">Cambiar de sucursal</span></a></li>';*/
var site_url_deliv="https://www.elglobo.com.mx/";
if(localStorage.getItem('suc_name')){
$('#active-sucursal').html(localStorage.getItem('suc_name'));
  $('#active-sucursal-movil').html(localStorage.getItem('suc_name'));
  var direccion_envio;
  if(localStorage.getItem('delivery_type')=='domicilio'){
    
    
    
  direccion_envio=localStorage.getItem('dir_street');
     $('.location2').show();
    $('.store').show();
    
  }else if(localStorage.getItem('delivery_type')=='recoger'){
  direccion_envio=localStorage.getItem('suc_dir');
    $('.store').show();
    
  }
   
  $('#active-sucursal-dir').html(((is_mobile)? 'Mi dirección: ' : '')+direccion_envio.slice(0,34)+'...');
  $('.active-suc-link').html('Cambiar');
  $('.mobile-ddown-btn').html('Cambiar');
  
}else{
 if($( window ).width() <1000){
     $('.mobile-ddown-btn').show();
      }
 
$('.active-suc-link').html('Elegir sucursal');
  $('#active-sucursal').html('--');
  $('#active-sucursal-movil').html('--');
}
/*$('.mobile-menu__nav').append(boton);*/


   $(document).on('click', '.edit-direccion',  function(){
  localStorage.setItem('edit_direccion', 'true');
  window.location.replace(site_url_deliv+'pages/delivery');
    }); 

$(document).ready(function() {
    //getHeight();
     var sucursal_cookie =  JSON.parse(getCookie('suc'));
  
  if(sucursal_cookie != null){
    console.log('"******** la sucursal en cookie es: '+sucursal_cookie.numero+' ********"');
    if(sucursal_cookie.numero && sucursal == null){
 
   console.log("******** estableciendo sucursal por cookie ********");
   setSucByCookie();
  }
  }else{
    console.log('"******** no hay sucursal en cookie ********"');
  }
 

});
$( window ).resize(function() {
 //getHeight();
});

/*
function getHeight(){

	
	var screen=$( window ).height();
 var foot=(7.38*screen)/100;
    $(".first-view").css('height',screen-foot+'px');
    $(".suc-footer").css('height',foot+'px');
    $(".suc-footer-logos").css('line-height',foot+'px');

} */

 
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + ";domain=elglobo.com.mx; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=;domain=elglobo.com.mx; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

var cook=getCookie('suc');
//console.log('cook',cook);
	
 function setSucCookie(sucdata){
      var cookie_value = new Object();
   cookie_value.numero = sucdata.selected_suc1;
    cookie_value.nombre = sucdata.selected_suc_name1;
    cookie_value.direccion = sucdata.selected_suc_dir1;
    cookie_value.horario = sucdata.selected_suc_horario1;
    cookie_value.telefono = sucdata.selected_suc_tel1;
     cookie_value.lat = sucdata.selected_suc_lat1;
     cookie_value.lon = sucdata.selected_suc_lon1;
    cookie_value.delivery_type = sucdata.delivery_type;
    
  
   var jsonString= JSON.stringify(cookie_value);
      eraseCookie('suc');
      setCookie('suc',jsonString,30);     
    
  }

function setSucByCookie(){

   backdrop('on');
    
        var cookie_obj = JSON.parse(getCookie('suc'));;

    const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


    $.post('/cart/update.js', "attributes[sucursal]=" + cookie_obj.numero);
  
    localStorage.setItem('sucursal', cookie_obj.numero);
    localStorage.setItem('suc_name', cookie_obj.nombre);
    localStorage.setItem('suc_dir', cookie_obj.direccion);
    localStorage.setItem('suc_horario', cookie_obj.horario);
    localStorage.setItem('suc_tel', cookie_obj.telefono);
    localStorage.setItem('suc_lat', cookie_obj.lat);
    localStorage.setItem('suc_lon', cookie_obj.lon);
   localStorage.setItem('delivery_type', cookie_obj.delivery_type);
  localStorage.setItem('sucData', getCookie('suc'));
 if(cookie_obj.delivery_type=="domicilio"){
console.log('si es domicilio *************');
    localStorage.setItem('dir_firstname', cookie_obj.dir_firstname);
    localStorage.setItem('dir_lastname', cookie_obj.dir_lastname);
      localStorage.setItem('dir_telephone', cookie_obj.dir_telephone);
      localStorage.setItem('dir_street', cookie_obj.dir_street);
      localStorage.setItem('dir_apartment', cookie_obj.dir_apartment);
      localStorage.setItem('dir_postal_code', cookie_obj.dir_postal_code);
      localStorage.setItem('dir_city', cookie_obj.dir_city);
  localStorage.setItem('dir_state', cookie_obj.dir_state);
  localStorage.setItem('dir_country', cookie_obj.dir_country);
  localStorage.setItem('dir_reference', cookie_obj.dir_reference);
 localStorage.setItem('dir_indications', cookie_obj.dir_indications);
  localStorage.setItem('dir_lat', cookie_obj.dir_lat);
 localStorage.setItem('dir_lon', cookie_obj.dir_lon);
  localStorage.setItem('quote_fee', cookie_obj.quote_fee);
localStorage.setItem('quote_duration', cookie_obj.quote_duration);
localStorage.setItem('quote_id', cookie_obj.quote_id);

localStorage.setItem('address1', cookie_obj.dir_street);
localStorage.setItem('address2', cookie_obj.dir_apartment);
  localStorage.setItem('zip',  cookie_obj.dir_postal_code);
  localStorage.setItem('city', cookie_obj.dir_city);


  localStorage.setItem('suggestion_lat', cookie_obj.dir_lat);
  localStorage.setItem('suggestion_lon', cookie_obj.dir_lon);
    var direccion_envio=cookie_obj.dir_street;
      $('#active-sucursal-dir').html(((is_mobile)? 'Mi dirección: ' : '')+direccion_envio.slice(0,34)+'...');
     $('.location2').show();
  }
 
  
 $('#active-sucursal').html(localStorage.getItem('suc_name'));
  $('#active-sucursal-movil').html(localStorage.getItem('suc_name'));
   $('.recoger').addClass('delivery-selected');
   $('.store').show();
   $('.active-suc-link').html('Cambiar');
  $('.mobile-ddown-btn').html('Cambiar');
 backdrop('off');
  
}



$(document).on('click', '#mov-active-suc-link',  function(){
 $('.delivery-header #active-sucursal').click();
}); 


// Deshabilitar selección de sucursal por recarga forzada
$(document).on('click', '.active-suc-link, .mobile-ddown-btn', function(e){
  e.preventDefault();
  location.reload(); 
});


  if(window.location.pathname === '/pages/sucursales'){
    window.location.href = '/nosotros'; 
  }

  if(localStorage.getItem('suc_name')) {
    localStorage.removeItem('suc_name');
localStorage.removeItem('sucursal');
localStorage.removeItem('suc_dir');
localStorage.removeItem('suc_horario');
localStorage.removeItem('suc_tel');
localStorage.removeItem('suc_lat');
localStorage.removeItem('suc_lon');
localStorage.removeItem('delivery_type');
localStorage.removeItem('sucData');


}